module.exports = __webpack_public_path__ + "assets/img/05fac038d62f4237228e29472c87a8c9.png";